import { useContext, useState } from "react";
import { useOutletContext } from "react-router";
import Button from "../../../sharable/ActionButton.jsx";
import PremiumContentProtectiveLayer from "../../../sharable/PremiumContentProtectiveLayer.jsx";
import Switch from "../../../sharable/Switch.jsx";
import WorkspaceContext from "../../WorkspaceContext.js";
import { MenuDescription, MenuTitle } from "../Toolbar.jsx";
import { CAPTION_TOGGLE_OPTIONS } from "./buildCaptionText.js";
import {
  Container,
  CopyButtonWrapper,
  CopyFeedback,
  PreviewTextarea,
  ToggleRow,
  TogglesWrapper,
} from "./CaptionMenuView.styles.js";

export default function CaptionMenuView() {
  const { caption, captionToggles, onCaptionTogglesChange } =
    useContext(WorkspaceContext);
  const { isAccountPremium } = useOutletContext();
  const [copied, setCopied] = useState(false);

  const handleToggle = (key, value) => {
    onCaptionTogglesChange((prev) => ({ ...prev, [key]: value }));
  };

  const handleCopy = async () => {
    await navigator.clipboard.writeText(caption);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Container isAccountPremium={isAccountPremium}>
      {!isAccountPremium && <PremiumContentProtectiveLayer />}
      <main>
        <MenuDescription>
          Monte a legenda do seu post para Instagram ou status do WhatsApp.
          Ative ou desative as informações que deseja incluir.
        </MenuDescription>
        <MenuTitle>legenda</MenuTitle>

        <TogglesWrapper>
          {CAPTION_TOGGLE_OPTIONS.map(({ key, label }) => (
            <ToggleRow key={key}>
              <span className="label">{label}</span>
              <Switch
                on={captionToggles[key]}
                callback={(value) => handleToggle(key, value)}
              />
            </ToggleRow>
          ))}
        </TogglesWrapper>

        <PreviewTextarea readOnly value={caption} />

        <CopyButtonWrapper copied={copied}>
          <Button
            text={copied ? "Legenda copiada" : "Copiar legenda"}
            action={handleCopy}
            $fullWidth
          />
        </CopyButtonWrapper>
      </main>
    </Container>
  );
}
